import React from 'react';
import { AlertCircle } from 'lucide-react';

type ErrorViewProps = {
  error: string;
  onRetry: () => void;
};

export const ErrorView: React.FC<ErrorViewProps> = ({ error, onRetry }) => {
  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center max-w-md">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">エラーが発生しました</h3>
        <p className="text-gray-600 mb-4">{error}</p>
        <button 
          onClick={onRetry}
          className="btn-primary"
        >
          再試行
        </button>
      </div>
    </div>
  );
};
